import { render, staticRenderFns } from "./DetalhesPagamento.vue?vue&type=template&id=1f8c0cbf&scoped=true&"
import script from "./DetalhesPagamento.vue?vue&type=script&lang=js&"
export * from "./DetalhesPagamento.vue?vue&type=script&lang=js&"
import style0 from "./DetalhesPagamento.vue?vue&type=style&index=0&id=1f8c0cbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8c0cbf",
  null
  
)

export default component.exports